import gql from 'graphql-tag';
import { ServerError, ServerParseError, useQuery } from '@apollo/client';

export const envQuery = gql`
  query EnvType {
    data @rest(type: "", path: "env") {
      env
      snbDltNodeName
    }
  }
`;

interface envConfig {
  loading: boolean;
  snbDltNodeName?: string;
  envType?: string;
  statusCode?: number;
}

type NetworkError = Error | ServerParseError | ServerError | null;

function isServerError(error?: NetworkError): error is ServerError {
  return (error as ServerError)?.statusCode !== undefined;
}

function isServerParseError(error?: NetworkError): error is ServerParseError {
  return (error as ServerParseError)?.statusCode !== undefined;
}

const useEnvConfig = (): envConfig => {
  const { data, loading, error } = useQuery<{ data: { env: string; snbDltNodeName: string } }>(envQuery, {
    errorPolicy: 'ignore',
  });
  const networkError = error?.networkError;
  const statusCode = isServerError(networkError) || isServerParseError(networkError) ? networkError.statusCode : undefined;
  return { loading, envType: data?.data.env, snbDltNodeName: data?.data.snbDltNodeName, statusCode };
};

export default useEnvConfig;
